<template>
  <div class="user-card">
    <div class="head">
      <div class="breadcrumbs">
        <RouterLink
          v-if="teamId"
          :to="`/teams/${teamId}/details/users`"
          class="back-link"
        >
          {{ teamInfo.name }}
        </RouterLink>
        <RouterLink
          v-else
          class="back-link"
          to="/teams/all/details/users"
        >
          {{ $t('teams.teams_fields.default_team') }}
        </RouterLink>
        <span class="divider">></span>
        <span class="email">{{ userInfo.name }}</span>
      </div>
      <div class="title-email">
        <h2>{{ userInfo.name }}</h2>
        <UiIcon
          v-if="userStatus === 'active'"
          :size="16"
          name="check"
          color="var(--text-primary)"
        />
        <UiIcon
          v-else
          :size="16"
          name="times-circle"
          color="var(--text-negative)"
        />
      </div>
    </div>
    <RouterView
      v-model:user-info="userInfo"
      :user-status="userStatus"
      class="view"
      @change-status="changeStatus"
      @get-user-info="getAdmin"
    />
  </div>
</template>

<script>

import sessionAction from '@/views/mixins/session-action';

export default {
  mixins: [sessionAction],

  data() {
    return {
      nav: [
        {
          name: 'info',
          link: 'info',
        },
      ],
      teamId: '',
      teamInfo: {},
      userInfo: {},
      userStatus: '',
      errors: {},
      currentTab: '',
    };
  },

  watch: {
    $route() {
      this.currentTab = this.$route.matched[2].meta.view;
    },
  },

  mounted() {
    this.onSessionUnlock = this.initData;
    this.initData();
  },
  methods: {
    initData() {
      this.currentTab = this.$route.matched[2].meta.view;
      this.teamId = this.$route.query.team_id ? this.$route.query.team_id : '';
      if (this.teamId) {
        this.getTeam(this.teamId);
      }
      this.getAdmin(this.$route.params.id);
    },
    isLinkActive(name) {
      return this.currentTab === name;
    },

    getTeam(id) {
      this.$api.getTeam(id).then((response) => {
        this.teamInfo = response.data.payload;
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },
    getAdmin(id) {
      this.$api.getAdmin(id).then((response) => {
        this.userInfo = response.data.payload;
        this.userStatus = this.userInfo.account_status;
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },
    changeStatus(val) {
      this.userStatus = val;
    },
  },
};

</script>

<style lang="scss" scoped>
  .user-card {
    .head {
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      width: 90%;
      min-width: 1140px;
      padding: 16px 0 0 0;
    }
  }
</style>
